import { FC } from 'react';

import ReactSelect from 'react-select';

import { isDefined } from '@hsp/utilities';

import { usePageSizes } from 'components/table/components/paginator/hooks';
import { useTableStoreSelector } from 'components/table/hooks/context';
import { PageSizesProps } from 'types/components/table/components/paginator';
import { s } from 'utilities/strings';

const PageSizes: FC<PageSizesProps> = ({ onPageSizeChanged, pageSizeOptions = [10, 25, 50, 100] }) => {
  const pageSize = useTableStoreSelector((state) => state.pageSize);
  const pageSizes = usePageSizes(pageSizeOptions);

  return (
    <div className="paginator-items-per-page">
      <div>{s('Site.ItemsPerPage', { suffix: ':' })}</div>
      <div className="ms-3">
        <ReactSelect
          menuPlacement="auto"
          onChange={(option) => {
            if (isDefined(option)) {
              onPageSizeChanged?.(option.value);
            }
          }}
          options={pageSizes}
          value={pageSizes.find((option) => option.value === pageSize)}
        />
      </div>
    </div>
  );
};

export default PageSizes;
